import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

const ResolveModal = ({ show, handleClose, data }: any) => {
  const [comment, setComment] = useState("");
  const userData = JSON.parse(localStorage.getItem("UserData") || "{}");
const [loading, setLoading] = useState(false);
  const handleResolve = () => {
    console.log("Resolving with comment:", userData);
    setLoading(true);
    WebService.putAPI({
      action: `contact-us/resolve/${data?._id}`,
      body: {
        comment,
        actionBy: {
          id: userData.id,
          name: userData.fullName,
          email: userData.email,
        },
      },
    })
      .then((res:any) => {
         setLoading(false);
        toast.success(res.message);
        handleClose();
      })
      .catch((err) => console.error(err));
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Resolve Contact Request</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Write resolution comment..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" disabled={loading} onClick={handleResolve}>
            {loading && <Spinner size="sm" className="me-2" />}
          Resolve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResolveModal;
